import { ColorModeScript } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ColorModeScript />
    <BrowserRouter>
      <Auth0Provider
        domain="dev-ha4ty1ze1y4otrpj.us.auth0.com"
        clientId="r7G9HEJ0KPM60s4OtAB7tcUccXsgWcMP"
        useRefreshTokens
        cacheLocation="localstorage"
        authorizationParams={{
          redirect_uri: window.location.origin,
        }}
      >
        <App />
      </Auth0Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
